module.exports = __webpack_public_path__ + "img/404.2520ab1a.svg";